var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    {
      attrs: {
        placement: "top",
        content: _vm.content,
        disabled: _vm.disabled,
        "popper-class": "qm-refresh",
      },
    },
    [
      _vm.$slots.default
        ? [_vm._t("default")]
        : [
            _c("i", {
              class: {
                "qm-refresh__icon": true,
                "qm-icon-refresh": true,
                "is-refreshing": _vm.$value,
              },
              style: { fontSize: _vm.size + "px" },
              on: { click: _vm.emitClick },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }